import React, { Component } from 'react';
import {BrowserRouter as Router, Route, Redirect} from 'react-router-dom';

import Bio from './Bio.js';
import Clients from './Clients.js'
import Contact from './Contact.js';
import Homepage from './Homepage.js';
import MenuBar from './MenuBar.js';
import PhotoGrid from './PhotoGrid.js';
import SingleImage from './SingleImage.js';

import {
  peopleNormalHeights, peopleNormalWidths,
  productNormalHeights, productNormalWidths,
  personalNormalHeights, personalNormalWidths
} from '../imagesInfo.js';


export default class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showWork: false,
      showDivider: false
    }

    this.getPeopleNormals = this.getPeopleNormals.bind(this);
    this.getProductNormals = this.getProductNormals.bind(this);
    this.getPersonalNormals = this.getPersonalNormals.bind(this);
    this.toggleDivider = this.toggleDivider.bind(this);
    this.toggleWork = this.toggleWork.bind(this);

    this.peopleNormals = this.getPeopleNormals();
    this.productNormals = this.getProductNormals();
    this.personalNormals = this.getPersonalNormals();
  }

  toggleDivider(bool) {
    this.setState(function() {
      return {
        showDivider: bool
      }
    });
  }

  toggleWork(bool) {
    /*this.setState(function () {
      return {
        showWork: bool
      }
    });*/
    this.setState({
      showWork: bool
    });
  }

  bio() {
    return (
      <Bio toggleWork={this.toggleWork} />
    )
  }

  clients() {
    return (
      <Clients toggleWork={this.toggleWork} />
    )
  }

  contact() {
    return (
      <Contact toggleWork={this.toggleWork} />
    )
  }

  divider() {
    return (
      this.state.showDivider ? <div className='main-divider'></div> : null
    )
  }

  homepage() {
    return (
      <Homepage
        toggleWork={this.toggleWork}
        toggleDivider={this.toggleDivider}
      />
    )
  }

  getPeopleNormals() {
    const imageObject = this.importImages(require.context('../images/people/normals', false));
    let imageList = [];

    for (let key in imageObject) {
      if (imageObject.hasOwnProperty(key)) {
        imageList.push(imageObject[key]);
      }
    }

    return imageList;
  }

  getProductNormals() {
    const imageObject = this.importImages(require.context('../images/products/normals', false));
    let imageList = [];

    for (let key in imageObject) {
      if (imageObject.hasOwnProperty(key)) {
        imageList.push(imageObject[key]);
      }
    }

    return imageList;
  }

  getPersonalNormals() {
    const imageObject = this.importImages(require.context('../images/personal/normals', false));
    let imageList = [];

    for (let key in imageObject) {
      if (imageObject.hasOwnProperty(key)) {
        imageList.push(imageObject[key]);
      }
    }

    return imageList;
  }

  importImages(r) {
    let images = {};
    r.keys().map((item, index) => { images[item.replace('./', '')] = r(item); });
    return images;
  }

  people() {
    return (
      <PhotoGrid
        toggleWork={this.toggleWork}
        imageType={'/work/people'}
      />
    )
  }

  personal() {
    return (
      <PhotoGrid
        toggleWork={this.toggleWork}
        imageType={'/work/personal'}
      />
    )
  }

  products() {
    return (
      <PhotoGrid
        toggleWork={this.toggleWork}
        imageType={'/work/products'}
      />
    )
  }

  singleImage(src, prev, next, section, h, w) {
    return (
      <SingleImage
        src={src}
        prev={prev}
        next={next}
        section={section}
        height={h}
        width={w}
        toggleWork={this.toggleWork}
      />
    )
  }

  render() {
    return (
      <Router>
        <div className='container'>
          <Route exact path ='/' render={this.homepage.bind(this)} />
          <div className='menu-bar-container'>
            <MenuBar showWork={this.state.showWork} toggleWork={this.toggleWork} />
          </div>
          {this.divider()}
          <div className='main-screen'>
            <Route exact path='/work' render={() => <Redirect push to='/work/people' />}/>

            {/* PEOPLE */}
            <Route exact path='/work/people' render={this.people.bind(this)} />
            {this.peopleNormals.map((image, i, arr) => {
              let len = arr.length;
              return (
                <Route
                  key={image}
                  exact path={'/work/people/'+ (i+1)}
                  render={() => {
                    let prev = (i-1) < 0 ? len : (i);
                    let next = (i+1) === len ? 1 : (i+2);
                    let h = peopleNormalHeights[i];
                    let w = peopleNormalWidths[i];
                    return this.singleImage(image, prev, next, '/work/people', h, w);
                  }}
                />
              )
            })}

            {/* PRODUCTS */}
            <Route exact path='/work/products' render={this.products.bind(this)} />
            {this.productNormals.map((image, i, arr) => {
              let len = arr.length;
              return (
                <Route
                  key={image}
                  exact path={'/work/products/'+ (i+1)}
                  render={() => {
                    let prev = (i-1) < 0 ? len : (i);
                    let next = (i+1) === len ? 1 : (i+2);
                    let h = productNormalHeights[i];
                    let w = productNormalWidths[i];
                    return this.singleImage(image, prev, next, '/work/products', h, w);
                  }}
                />
              )
            })}

            {/* PERSONAL */}
            <Route exact path='/work/personal' render={this.personal.bind(this)} />
            {this.personalNormals.map((image, i, arr) => {
              let len = arr.length;
              return (
                <Route
                  key={image}
                  exact path={'/work/personal/'+ (i+1)}
                  render={() => {
                    let prev = (i-1) < 0 ? len : (i);
                    let next = (i+1) === len ? 1 : (i+2);
                    let h = personalNormalHeights[i];
                    let w = personalNormalWidths[i];
                    return this.singleImage(image, prev, next, '/work/personal', h, w);
                  }}
                />
              )
            })}


            <Route exact path='/clients' render={this.clients.bind(this)} />
            <Route exact path='/bio' render={this.bio.bind(this)} />
            <Route exact path='/contact' render={this.contact.bind(this)} />
          </div>
        </div>
      </Router>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js